/* ==========================================================================
   Nav Colour Change with No Hero
   ========================================================================== */

// ...

var heroExists = document.getElementById("hero");
var navClass = document.getElementById("menu");
var buttonClass = document.getElementById("tenant-link");

if (!document.body.contains(heroExists)) {
  navClass?.classList.add("no-hero");
  buttonClass?.classList.add("no-hero");
}
